import { useCallback, useMemo } from "react";
import { message } from "antd";
import styles from "../index.module.scss";
import { IRenderContentEvent } from "../index";

const TimeStamp = ({
  time,
  onEvent,
}: {
  time: string;
  onEvent?: (e: IRenderContentEvent) => void;
}) => {
  const handleClick = useCallback(() => {
    if (onEvent) {
      const [startTime, endTime] = time.split("-");
      // const [startMin, startSec] = startTime.split(":");
      // const [endMin, endSec] = endTime.split(":");
      onEvent({
        type: "videoTimeClick",
        data: { seekTime: startTime, videoIndex: 0 },
      });
    }
  }, [time, onEvent]);

  return (
    <span
      className={styles.timestamp}
      onClick={handleClick}
      role="button"
      tabIndex={0}
    >
      [{time}]
    </span>
  );
};

export default TimeStamp;
